import gql from "graphql-tag";

export const DELETE_PAVING_FOREMAN = gql`
  mutation deletePavingForeman($where: DeletePavingForeman!){
    deletePavingForeman(where: $where)
  }
`;